import { useQuery } from '@tanstack/react-query';
import { getDistinctValuesForFilter } from './getGLControlData';
import { GRC18956_REGIONS } from '../../constants';

export interface LedgerOption {
  label: string;
  value: string;
}

const fetchLedgerNames = async (
  controlId: string,
  selectedRegions: string[],
  dataType: string
): Promise<LedgerOption[]> => {
  if (!controlId.startsWith('grc18956')) {
    return [];
  }
  const regions = dataType === 'PO' ? GRC18956_REGIONS : selectedRegions;
  const ledgerNames = await getDistinctValuesForFilter(
    controlId,
    'ledger_name',
    undefined,
    undefined,
    regions
  );
  return ledgerNames.map((ledger) => ({ label: ledger, value: ledger }));
};

export const useLedgerName = (
  controlId: string,
  selectedRegions: string[] = [],
  dataType: string
) => {
  return useQuery({
    queryKey: ['ledgerNames', controlId, selectedRegions, dataType],
    queryFn: () => fetchLedgerNames(controlId, selectedRegions, dataType),
    enabled: Boolean(controlId && (controlId === 'grc18956openpo' || selectedRegions.length > 0)),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
